export default __webpack_public_path__ + "static/media/6.e91fb499.jpg";